import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function initBannerSlider(query = document.querySelectorAll('.js-bannerSlider')) {
    for (const el of query) {
        if (el.dataset.bannerSliderInit) {
            continue;
        }
        el.dataset.bannerSliderInit = "true";

        const wrapper = el.closest('.bannerSlider');
        const slideCount = el.querySelectorAll('.swiper-slide').length;

        if (slideCount <= 1) {
            wrapper?.classList.add('bannerSlider--single');
            continue;
        }

        new Swiper(el, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            speed: 400,
            loop: true,
            navigation: {
                nextEl: wrapper.querySelector('.js-bannerSliderNext'),
                prevEl: wrapper.querySelector('.js-bannerSliderPrev'),
            },
            pagination: {
                el: wrapper.querySelector('.js-bannerSliderPagination'),
                clickable: true,
            },
        });
    }
}
